module.exports = __webpack_public_path__ + "static/media/private-pool.3e5cf1b2.webp";